import { render, staticRenderFns } from "./delivery-page-block.vue?vue&type=template&id=0ee5fe37"
import script from "./delivery-page-block.vue?vue&type=script&lang=js"
export * from "./delivery-page-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackreeve/projects/logshed/wp-content/themes/logshed/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ee5fe37')) {
      api.createRecord('0ee5fe37', component.options)
    } else {
      api.reload('0ee5fe37', component.options)
    }
    module.hot.accept("./delivery-page-block.vue?vue&type=template&id=0ee5fe37", function () {
      api.rerender('0ee5fe37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/delivery-page-block.vue"
export default component.exports